module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesCreative@2x.287f918.jpg";